import { render } from "./MailTemplateForm.vue?vue&type=template&id=5008d2a5"
import script from "./MailTemplateForm.vue?vue&type=script&lang=js"
export * from "./MailTemplateForm.vue?vue&type=script&lang=js"

import "./MailTemplateForm.vue?vue&type=style&index=0&id=5008d2a5&lang=scss"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__